import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Parceiros() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new FormData(e.currentTarget);
      const formBody = new URLSearchParams();
      
      formData.forEach((value, key) => {
        formBody.append(key, value.toString());
      });

      const response = await fetch('https://readdy.ai/api/form/parceria-kudima', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        e.currentTarget.reset();
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const partners = [
    {
      name: 'Inapem',
      logo: './logo/logo2.jpg',
    },
    {
      name: 'Inapem',
      logo: './logo/logo1a.jpg',
    },
    {
      
      name: 'Transtrevo',
      logo: './logo/logo4.jpg',
    },
    {
      name: 'Pepek',
      logo: './logo/logofgc.jpg',
      size: 'large'
    },
    {
      name: 'Crecer',
      logo: './logo/logo6.jpg',
    },
    {
      name: 'FGC',
      logo: './logo/logo7.jpg',
    },
    
    {
      name: 'UNICEF',
      logo: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/b642e3ed2875398379a3e6bc59e773e2.jpeg',
    },
    {
      name: 'Joinstar',
      logo: './logo/logoo.jpg',
    },
    {
      name: 'Lugatech',
      logo: './logo/logo10.jpg',
    },
    {
      name: 'Global Partners',
      logo: './logo/logo11.jpg',
    },
    {
      name: 'Innovation Hub',
      logo: './logo/logo12.jpg',
    },
    {
      name: 'Strategic Solutions',
      logo: './logo/logotrans.jpg',
    },
  
  ];

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">Parceiros</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-black mb-6">NOSSOS PARCEIROS</h1>
          <p className="text-xl md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            Organizações nacionais e internacionais que confiam na +Kudima para o desenvolvimento de soluções.
          </p>
        </div>
      </section>

      {/* Partners Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">Quem Confia na +Kudima</h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
            {partners.map((partner, index) => (
              <div
                key={index}
                className="flex items-center justify-center p-6 bg-white rounded-xl border border-gray-200 hover:border-[#CB9832] hover:shadow-lg transition-all group cursor-pointer"
              >
                <div className={`w-full flex items-center justify-center ${partner.size === 'large' ? 'h-32' : 'h-20'}`}>
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="w-full h-full object-contain grayscale group-hover:grayscale-0 group-hover:scale-110 transition-all"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Benefits Section */}
      <section className="py-24 bg-[#F8F8F8]">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {[
        {
          icon: 'ri-team-line',
          title: 'REDE DE CONTACTOS',
          description: 'Acesso a uma rede exclusiva de empresas e profissionais de alto nível.'
        },
        {
          icon: 'ri-lightbulb-line',
          title: 'INOVAÇÃO CONJUNTA',
          description: 'Desenvolvimento de soluções inovadoras através da colaboração estratégica.'
        },
        {
          icon: 'ri-line-chart-line',
          title: 'CRESCIMENTO MÚTUO',
          description: 'Oportunidades de crescimento e expansão para todos os parceiros.'
        },
        {
          icon: 'ri-award-line',
          title: 'CREDIBILIDADE',
          description: 'Associação com uma marca reconhecida no mercado corporativo.'
        },
        {
          icon: 'ri-global-line',
          title: 'VISIBILIDADE',
          description: 'Exposição da sua marca em eventos e materiais de comunicação.'
        },
        {
          icon: 'ri-customer-service-2-line',
          title: 'SUPORTE DEDICADO',
          description: 'Equipe especializada para apoiar o desenvolvimento da parceria.'
        }
      ].map((benefit, index) => (
        <div key={index} className="bg-white p-8 rounded-xl shadow-sm">
          <div className="w-12 h-12 bg-[#f0f4f2] rounded-full flex items-center justify-center mb-6">
            <i className={`${benefit.icon} text-2xl text-[#1a3a32]`}></i>
          </div>
          
          {/* Título com tamanho reduzido para text-base, mantendo o estilo original */}
          <h3 className="text-base font-bold text-black mb-3">
            {benefit.title}
          </h3>
          
          <p className="text-gray-600">
            {benefit.description}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>

      {/* Seja Parceiro Section */}
      {/*  <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Right Side - Form 
            <div className="bg-[#F8F8F8] rounded-3xl p-8 shadow-xl lg:col-span-2 max-w-3xl mx-auto w-full">
              <h3 className="text-3xl font-bold text-black mb-6 text-center">FORMULÁRIO DE PARCERIA</h3>
              <form id="parceria-form" data-readdy-form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">Nome da Empresa *</label>
                  <input
                    type="text"
                    name="empresa"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#CB9832] focus:border-transparent"
                    placeholder="Sua empresa"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">Segmento *</label>
                  <select
                    name="segmento"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border-2 border-gray-200 text-gray-900 focus:outline-none focus:ring-2 focus:ring-[#CB9832] focus:border-transparent"
                  >
                    <option value="">Selecione o segmento</option>
                    <option value="tecnologia">Tecnologia</option>
                    <option value="consultoria">Consultoria Estratégica</option>
                    <option value="industria">Indústria</option>
                    <option value="servicos">SERVIÇOS</option>
                    <option value="comercio">Comércio</option>
                    <option value="outro">Outro</option>
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">Nome Completo *</label>
                  <input
                    type="text"
                    name="nome"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#CB9832] focus:border-transparent"
                    placeholder="Seu nome"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">E-mail Corporativo *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#CB9832] focus:border-transparent"
                    placeholder="seu@email.com"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">Telefone *</label>
                  <input
                    type="tel"
                    name="telefone"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#CB9832] focus:border-transparent"
                    placeholder="(+244) 900 000 000"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-2">Mensagem</label>
                  <textarea
                    name="mensagem"
                    rows={4}
                    maxLength={500}
                    className="w-full px-4 py-3 rounded-lg bg-white border-2 border-gray-200 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#CB9832] focus:border-transparent resize-none"
                    placeholder="Conte-nos mais sobre sua empresa e interesse em parceria..."
                  ></textarea>
                  <p className="text-sm text-gray-500 mt-1">Máximo de 500 caracteres</p>
                </div>

                {submitStatus === 'success' && (
                  <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-lg">
                    <i className="ri-checkbox-circle-line mr-2"></i>
                    Solicitação enviada com sucesso! Entraremos em contato em breve.
                  </div>
                )}

                {submitStatus === 'error' && (
                  <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg">
                    <i className="ri-error-warning-line mr-2"></i>
                    Erro ao enviar solicitação. Por favor, tente novamente.
                  </div>
                )}

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-[#2D5F3F] text-white px-6 py-4 rounded-lg font-bold text-lg hover:bg-[#234A32] transition-all shadow-xl whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin mr-2"></i>
                      Enviando...
                    </>
                  ) : (
                    'Enviar Solicitação'
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials from Partners */}
      {/* <section className="py-24 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">O Que Dizem Nossos Parceiros</h2>
            <p className="text-lg text-gray-600">Depoimentos de quem já faz parte da nossa rede</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                name: 'Eduardo Martins',
                role: 'CEO, TechCorp Solutions',
                text: 'A parceria com a Kudima foi transformadora para nosso negócio. O suporte e as oportunidades geradas superaram todas as expectativas.',
                image: 'https://readdy.ai/api/search-image?query=professional%20business%20executive%20man%20in%20modern%20corporate%20office%20wearing%20elegant%20suit%20confident%20smile%20natural%20lighting%20clean%20simple%20background%20professional%20headshot%20portrait&width=400&height=400&seq=partner-testimonial-1&orientation=squarish'
              },
              {
                name: 'Luciana Rocha',
                role: 'Diretora, Innovation Labs',
                text: 'Ser parceiro da Kudima abriu portas para novos mercados e nos conectou com clientes que buscam excelência e inovação.',
                image: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20executive%20in%20modern%20corporate%20office%20wearing%20elegant%20business%20attire%20confident%20smile%20natural%20lighting%20clean%20simple%20background%20professional%20headshot%20portrait&width=400&height=400&seq=partner-testimonial-2&orientation=squarish'
              },
              {
                name: 'Ricardo Santos',
                role: 'Fundador, Global Ventures',
                text: 'A credibilidade e o profissionalismo da Kudima agregam valor real à nossa marca. Uma parceria estratégica de sucesso.',
                image: 'https://readdy.ai/api/search-image?query=professional%20business%20executive%20man%20in%20modern%20corporate%20office%20wearing%20elegant%20suit%20confident%20smile%20natural%20lighting%20clean%20simple%20background%20professional%20headshot%20portrait&width=400&height=400&seq=partner-testimonial-3&orientation=squarish'
              }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow">
                <div className="flex items-center mb-6">
                  <img 
                    src={testimonial.image} 
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover mr-4"
                  />
                  <div>
                    <h3 className="font-bold text-lg text-black">{testimonial.name}</h3>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed italic">"{testimonial.text}"</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      <Footer />
    </div>
  );
}
